import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import Input from "antd/es/input/Input";
import DeleteConfirmationModal from "../../../../src/components/Modal/DeleteConfirmation";
import { Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CCollapse, CLink } from "@coreui/react";
import {
  Dashboard,
  settings,
  Product,
  Users1,
  Vehicle,
  Wrench,
  calendar,
  Employee,
  Suppliers,
  Home,
  Sales1,
  GiftCard,
  Email,
  Receiving,
  Expense,
  Places,
} from "../../../common/imagePath";
import { checkUserPermission } from "../../../common/UserPermission";
const ReportList = (props) => {
  const [loading, setLoading] = useState(false);

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />
      <div className="page-wrapper card-head">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header"
           style={
            {
              position: "fixed",
              top: "2px",
              zIndex: "999"
            }
          }
          >
            <div className="row"  style={{ marginTop: "5px" }} >
              {/* <div className="col"> */}
                <h3 className="page-title">Reports</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Reports</li>
                </ul>
              {/* </div> */}
            </div>
          </div>

          {/* Company Information */}
          {/* <div ref={CompanyInformationRef}>
            <CompanyInformation visibleInformationChange={companyInformation} />
          </div> */}

          {checkUserPermission('/expense-report') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-calendar"></i> Expense Report
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/expense-report"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Expense Report
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
          ""
        )}
          
          {(checkUserPermission('/Customer-Balance-Summary') || checkUserPermission('/customer-balance-detail'))? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="ti-layout-grid3"></i>Customer Balance Summary
                    </h4>
                    <div class="row">
                    {checkUserPermission('/Customer-Balance-Summary') ? (
                      <div class="list-group col-md-6">
                        <a
                          href="/Customer-Balance-Summary"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Customer Balance
                          Summary
                        </a>
                      </div>
                      ) : (
                        ""
                      )}

                      {checkUserPermission('/Customer-balance-detail') ? ( 
                      <div class="list-group col-md-6">
                        <a
                          href="/customer-balance-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Customer Balance
                          Detail
                        </a>
                      </div>
                       ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            ) : (
              ""
            )}
          
          {checkUserPermission('/invoices-and-received-payments') ? ( 
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-close"></i>Invoices and Received Payments
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/invoices-and-received-payments"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Invoices and Received
                          Payments
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           ) : (
            ""
          )}
          
          {checkUserPermission('/open-invoices') ? ( 
           <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Open Invoices
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/open-invoices"
                          class="list-group-item "
                          target="_blank"
                        >
                          <i class="fa fa-search report-icon"></i> Open Invoices
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            ) : (
              ""
            )}
          
          {(checkUserPermission('/customer-contact-list') || checkUserPermission('/vendor-contact-list') || checkUserPermission('/employee-contact-list'))? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Contact List
                    </h4>
                    <div class="row">
                      {checkUserPermission('/customer-contact-list') ? ( 
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="/customer-contact-list"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i>Customer Contact
                          List
                        </a>
                      </div>
                        ) : (
                          ""
                        )}
                      
                      {checkUserPermission('/vendor-contact-list') ? ( 
                       <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="/vendor-contact-list"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Vendor Contact List
                        </a>
                      </div>
                      ) : (
                        ""
                      )}
                      
                      {checkUserPermission('/employee-contact-list') ? ( 

                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="/employee-contact-list"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i> Employee Contact List
                        </a>
                      </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
          )}
        
        {checkUserPermission('/sales-by-customer-detail') ? ( 
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-user"></i>Sales by Customer Detail
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/sales-by-customer-detail"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Sales by
                          Customer Detail
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
          )}
        
        {checkUserPermission('/sales-by-customer-type-detail') ? ( 
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-delete"></i> Sales by Customer Type Detail
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/sales-by-customer-type-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="fa fa-calendar"></i> Sales by Customer Type
                          Detail
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
          
          {checkUserPermission('/sales-by-product-service-detail') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-delete"></i>Sales by Product/Service
                      Detail
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/sales-by-product-service-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i> Sales by
                          Product/Service Detail
                        </a>
                      </div>


                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
            )}


         {(checkUserPermission('/transaction-list-by-customer') || checkUserPermission('/transaction-list-by-vendor') || checkUserPermission('/transaction-list-by-date'))? (
           <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-delete"></i> Transaction List
                    </h4>
                    <div class="row">
                     {checkUserPermission('/transaction-list-by-customer') ? (
                       <div class="list-group col-md-4">

                        <a
                          href="/transaction-list-by-customer"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Transaction List by
                          Customer
                        </a>
                      </div>
                       ) : (
                        ""
                        )}

                     {checkUserPermission('/transaction-list-by-vendor') ? (
                       <div class="list-group col-md-4">
                      
                        <a
                          href="/transaction-list-by-vendor"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-stats-down"></i> Transaction List by
                          Vendor
                        </a>
                      </div>
                         ) : (
                          ""
                          )}
                     {checkUserPermission('/transaction-list-by-date') ? (
                       <div class="list-group col-md-4">
                         <a
                          href="/transaction-list-by-date"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-stats-down"></i> Transaction List by
                          Date
                        </a>
                      </div>
                       ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
          )}
          
          {checkUserPermission('/sales-by-customer-summary-report') ? (
            <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Sales by Customer Summary
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          class="list-group-item"
                          href="/sales-by-customer-summary-report"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Sales by
                          Customer Summary
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
            )}

           {(checkUserPermission('/vendor-balance-detail') ||  checkUserPermission('/vendor-balance-summary')) ?(
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Vendor Balance
                    </h4>
                    <div class="row">
                      {checkUserPermission('/vendor-balance-detail') ? (
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="/vendor-balance-detail"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i>Vendor Balance Detail
                        </a>
                      </div>
                      ) : (
                        ""
                        )}

                    {checkUserPermission('/vendor-balance-summary') ? (
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="/vendor-balance-summary"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i>Vendor Balance Summary
                        </a>
                      </div>
                       ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           ) : (
            ""
            )}
          
          {checkUserPermission('/expenses-by-vendor-summary') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Expenses by Vendor Summary
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/expenses-by-vendor-summary"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Expenses by Vendor
                          Summary
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           ) : (
            ""
            )}
          
          {(checkUserPermission('/open-purchase-order-list') || checkUserPermission('/open-purchase-order-detail'))? (
           <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Open Purchase Order List
                    </h4>
                    <div class="row">
                      {checkUserPermission('/open-purchase-order-list') ? (
                       <div class="list-group col-md-6">
                        <a
                          href="/open-purchase-order-list"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-stats-down"></i>Open Purchase Order
                          List
                        </a>
                      </div>
                       ) : (
                        ""
                        )}

                    {checkUserPermission('/open-purchase-order-detail') ? (
                      <div class="list-group col-md-6">
                        <a
                          href="open-purchase-order-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i>Open Purchase Order
                          Detail
                        </a>
                      </div>
                      ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
            )}
        {checkUserPermission('/income-by-customer-summery') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i> Income by Customer Summary
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/income-by-customer-summery"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-stats-down"></i>Income by Customer
                          Summary
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
         ) : (
          ""
          )}
          
        {checkUserPermission('/sales-by-product-service-summery') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Sales by Product/Service
                      Summary
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/sales-by-product-service-summery"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i>Sales by
                          Product/Service Summary
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
          )}
          
        {checkUserPermission('/trial-balance') ? (
           <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Trial Balance
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/trial-balance"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Trial Balance
                        </a>
                      </div>

                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
          )}
          
        {(checkUserPermission('/balance-sheet-summary') || checkUserPermission('/balance-sheet-detail')) ? (
         <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Balance Sheet
                    </h4>
                    <div class="row">
                     {checkUserPermission('/balance-sheet-summary') ? (
                       <div class="list-group col-md-6">
                        <a
                          href="/balance-sheet-summary"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i>Balance Sheet Summary
                        </a>
                      </div>
                      ) : (
                        ""
                        )}

                     {checkUserPermission('/balance-sheet-detail') ? (
                       <div class="list-group col-md-6">
                        <a
                          href="/balance-sheet-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i>Balance Sheet Detail
                        </a>
                      </div>
                       ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
        ""
        )}
            
          {checkUserPermission('/profit-and-loss-detail') ? (
          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Profit and Loss
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-12">
                        <a
                          href="/profit-and-loss-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i>  Profit and Loss Detail
                        </a>
                      </div>
                      {/* <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_manufacturers"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i>Profit and Loss by Customer
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
            )}
          
          {((checkUserPermission('/accounts-payable-aging-detail') || checkUserPermission('/accounts-payable-aging-summary') || checkUserPermission('/bill-payment-list')) || checkUserPermission('/bills-applied-payments') || checkUserPermission('/unpaid-bills'))? (
           <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i> Accounts Payable
                    </h4>
                    <div class="row">
                    {checkUserPermission('/accounts-payable-aging-detail') ? (
                      <div class="list-group col-md-6">
                        <a
                          href="/accounts-payable-aging-detail"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Accounts payable aging detail
                        </a>
                      </div>
                         ) : (
                          ""
                          )}
                    {checkUserPermission('/accounts-payable-aging-summary') ? (
                      
                      <div class="list-group col-md-6">
                        <a
                          href=""
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Accounts payable aging summary
                        </a>
                      </div>
                        ) : (
                          ""
                          )}
                    </div>
                    <div class="row mt-3">
                    {checkUserPermission('/bill-payment-list') ? (

                      <div class="list-group col-md-4">
                        <a
                          href="/bill-payment-list"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Bill Payment List
                        </a>
                      </div>
                    ) : (
                      ""
                      )}
                    {checkUserPermission('/bills-applied-payments') ? (
                      
                      <div class="list-group col-md-4">
                        <a
                          href="/bills-applied-payments"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i> Bills and Applied Payments
                        </a>
                      </div>
                       ) : (
                        ""
                        )}

                    {checkUserPermission('/unpaid-bills') ? (
                      <div class="list-group col-md-4">
                        <a
                          href="/unpaid-bills"
                          class="list-group-item"
                          target="_blank"
                        >
                          <i class="icon ti-calendar"></i> Unpaid Bills
                        </a>
                      </div>
                       ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
           ) : (
            ""
            )}
          
          {(checkUserPermission('/accounts-receivable-aging-summary') || checkUserPermission('/accounts-receivable-aging-detail')) ? (

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Accounts Receivable
                    </h4>
                    <div class="row">
                    {checkUserPermission('/accounts-receivable-aging-summary') ? (

                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="/accounts-receivable-aging-summary"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i>Accounts receivable aging summary
                        </a>
                      </div>
                        ) : (
                          ""
                          )}

                    {checkUserPermission('/accounts-receivable-aging-detail') ? (
                       <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="/accounts-receivable-aging-detail"
                          target="_blank"
                        >
                          <i class="icon ti-receipt"></i> Accounts receivable aging detail
                        </a>
                      </div>
                       ) : (
                        ""
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            ""
            )}

          {/*  <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Profit and Loss
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_profit_and_loss"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_profit_and_loss"
                        >
                          <i class="icon ti-calendar"></i> Detailed Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Registers
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_registers"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Summary Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_registers"
                          class="list-group-item"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Sales
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_journal"
                        >
                          <i class="icon ti-receipt"></i> Summary Journal report
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_sales"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Reports
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_sales"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_sales"
                        >
                          <i class="icon ti-calendar"></i> Detailed Reports
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_sales_day_of_week"
                        >
                          <i class="icon ti-receipt"></i> Day of Week Report
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_ecommerce_sales"
                        >
                          <i class="icon ti-calendar"></i> E-Commerce
                        </a>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_sales_locations"
                        >
                          <i class="icon ti-receipt"></i> Locations
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_tips"
                        >
                          <i class="ion-cash"></i> Tips
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_last_4_cc"
                        >
                          <i class="icon ti-calendar"></i> Last 4 of Credit Card
                        </a>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_sales_time"
                        >
                          <i class="icon ti-receipt"></i> Summary Sales by Time
                          Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          class="list-group-item"
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_sales_time"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Summary Sales by Time Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Receiving
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_categories_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary Categories
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/transfers"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Transfers
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Detailed Reports
                        </a>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_suspended_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Suspended Receivings
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/deleted_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Deleted Receivings
                          Report
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_taxes_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary taxes report
                        </a>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_taxes_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          summary taxes report
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/cheapest_supplier"
                          class="list-group-item"
                        >
                          <i class="icon ti-download"></i> Cheapest Supplier
                        </a>
                      </div>
                    </div>
                    <br />
                    <h4 class="text-info">Items</h4>
                    <div class="row mt-3">
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_items_receivings"
                          class="list-group-item"
                        >
                          <i class="ti-bar-chart-alt"></i> Graphical Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_items_receivings"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                    </div>
                    <br />
                    <h4 class="text-info">Payments</h4>
                    <div class="row mt-3">
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/receivings_graphical_summary_payments"
                          class="list-group-item"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Reports
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/receivings_summary_payments"
                          class="list-group-item text-warning"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                      <div class="list-group col-md-4">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/receivings_detailed_payments"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Detailed Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Suspended Sales
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/detailed_suspended_sales"
                          class="list-group-item"
                        >
                          <i class="icon ti-calendar"></i> Detailed Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/layaway_statements"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Layaway Statements
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Tags
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_tags"
                          class="list-group-item"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_tags"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Taxes
                    </h4>
                    <div class="row">
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/graphical_summary_taxes"
                          class="list-group-item"
                        >
                          <i class="icon ti-bar-chart-alt"></i> Graphical
                          Reports
                        </a>
                      </div>
                      <div class="list-group col-md-6">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_taxes"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
{/*  */}
          {/* <div className="card">
            <div className="card-header">
              <div className="card-title ">
                <div class="panel">
                  <div class="panel-body child-list">
                    <h4 class="border-bottom mb-4">
                      <i class="fa fa-search"></i>Tiers
                    </h4>
                    <div class="row">
                      <div class="list-group">
                        <a
                          href="https://demo.phppointofsale.com/index.php/reports/generate/summary_tiers"
                          class="list-group-item"
                        >
                          <i class="icon ti-receipt"></i> Summary Reports
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>  */}
        </div>
      </div>
    </>
  );
};

export default ReportList;
